class SystemFinder extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isOpen = false
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTrigger)
    })
  }

  handleTrigger (event) {
    const trigger = event.target.closest(this.els?.trigger?.selector)
    const filter = this.els[`filter-${trigger.dataset.filter}`].element

    trigger.classList.toggle('drw-SystemFilter_Button-active')

    this.filtersDiscipline = []
    this.filtersClimate = []

    this.els.trigger.elements.forEach((triggerEl) => {
      if (!triggerEl.classList.contains('drw-SystemFilter_Button-active')) {
        return
      }
      if (triggerEl.classList.contains('drrw-SystemFilter_Button-disabled')) {
        return
      }

      if (triggerEl.dataset.filter === 'discipline') {
        this.filtersDiscipline.push(triggerEl.dataset.value)
      } else if (triggerEl.dataset.filter === 'climate') {
        this.filtersClimate.push(triggerEl.dataset.value)
      }
    })

    this.countFilters = 0
    if (trigger.dataset.filter === 'climate') {
      this.countFilters = this.filtersClimate.length
    } else {
      this.countFilters = this.filtersDiscipline.length
    }

    filter.innerHTML = `(${this.countFilters})`
    this.filterItems(this.filtersDiscipline, this.filtersClimate)
  }

  filterItems (disciplines, climates) {
    const visibleSystems = []

    this.els.system.elements.forEach((systemEl) => {
      const systemDisciplines = systemEl.dataset.disciplines
        .split(',')
        .map((v) => v.trim())
      const systemClimate = systemEl.dataset.climate

      const matchesDiscipline =
        disciplines.length === 0 ||
        disciplines.some((discipline) =>
          systemDisciplines.includes(discipline),
        )
      const matchesClimate =
        climates.length === 0 ||
        climates.some((climate) => systemClimate.includes(climate))

      if (matchesDiscipline && matchesClimate) {
        systemEl.style.display = 'block'
        visibleSystems.push(systemEl)
      } else {
        systemEl.style.display = 'none'
      }
    })

    this.updateClimateAvailability(visibleSystems)

    if (disciplines.length === 0 && climates.length === 0) {
      this.els.system.elements.forEach((systemEl) => {
        systemEl.style.display = 'block'
      })
    }
  }

  updateClimateAvailability (systems) {
    const availableClimates = new Set()

    systems.forEach((systemEl) => {
      availableClimates.add(systemEl.dataset.climate)
    })

    this.els.trigger.elements.forEach((triggerEl) => {
      if (triggerEl.dataset.filter !== 'climate') return

      const climate = triggerEl.dataset.value

      if (availableClimates.has(climate)) {
        triggerEl.classList.remove('drw-SystemFilter_Button-disabled')
      } else {
        triggerEl.classList.add('drw-SystemFilter_Button-disabled')
        triggerEl.classList.remove('drw-SystemFilter_Button-active')
      }
    })
  }
}

if (!customElements.get('system-finder')) {
  customElements.define('system-finder', SystemFinder)
}
